import { render, staticRenderFns } from "./siteBatchBooksDialog.vue?vue&type=template&id=5f124763&scoped=true"
import script from "./siteBatchBooksDialog.vue?vue&type=script&lang=js"
export * from "./siteBatchBooksDialog.vue?vue&type=script&lang=js"
import style0 from "./siteBatchBooksDialog.vue?vue&type=style&index=0&id=5f124763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f124763",
  null
  
)

export default component.exports